import { StyleSheet, Dimensions, Platform } from 'react-native';
const { width, height } = Dimensions.get('window');

export default StyleSheet.create({

  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fundo translúcido
  },
  loadingText: {
    color: '#FFF',
    marginTop: 10,
    fontSize: 16,
  },


  contentMinimal: {
    flexGrow: 1,
    backgroundColor: '#f5f5f5',
    paddingHorizontal: 24,
    paddingTop: 48,
    alignItems: 'center',
  },

  title: {
    fontSize: 22,
    fontWeight: '700',
    textAlign: 'center',
    color: '#1F2024',
    marginBottom: 16,
  },

  container: {
    width: '100%',
    maxWidth: 480,
    alignItems: 'center',
  },

  row: {
    width: '100%',
    marginBottom: 24,
  },

  checkboxLabel: {
    textAlign: 'justify',
    fontSize: 15,
    lineHeight: 22,
    color: '#1F2024',
  },

  optionButtonsContainer: {
    width: '100%',
    marginTop: 8,
  },

  optionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    borderColor: '#E0E0E0',
    borderWidth: 1,
    borderRadius: 10,
    paddingVertical: 14,
    paddingHorizontal: 18,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOpacity: 0.04,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 2,
    elevation: 1,
  },

  optionIcon: {
    width: 24,
    height: 24,
    marginRight: 12,
    // tintColor: '#730d83',
  },

  optionTextContainer: {
    flex: 1,
  },

  optionTextTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#1F2024',
  },

  optionTextSubtitle: {
    fontSize: 11,
    color: '#7A7A7A',
  },

  buttonContainer: {
    marginTop: 32,
    alignItems: 'center',
  },

  laterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  laterIcon: {
    width: 20,
    height: 20,
    marginRight: 8,
    tintColor: '#730d83',
  },

  laterButtonText: {
    color: '#730d83',
    fontSize: 15,
    fontWeight: '600',
  },

  // 

  cardStatus: (status) => ({
    fontWeight: 'bold',
    color: status === 'concluida' ? '#2E7D32' : status === 'em_progresso' ? '#F9A825' : '#C62828',
  }),

  // modal 

  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    zIndex: 1000,
  },

  modalContainer: {
    width: 600,
    maxWidth: '90%',
    backgroundColor: '#730d83',
    borderRadius: 20,
    paddingVertical: 30,
    paddingHorizontal: 40,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },

  closeButton: {
    position: 'absolute',
    top: 15,
    right: 15,
    zIndex: 1,
  },

  modalTitle: {
    fontSize: 24,
    color: '#FFF',
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
  },

  categoryContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    width: '100%',
    gap: 20,
  },

  categoryButton: {
    width: 120,
    height: 120,
    backgroundColor: '#FFF',
    borderRadius: 15,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },

  categoryIcon: {
    width: 50,
    height: 50,
    resizeMode: 'contain',
  },

  categoryText: {
    marginTop: 10,
    fontSize: 14,
    color: '#730d83',
    fontWeight: 'bold',
    textAlign: 'center',
  },

});
